import { LegacyCustomTable } from 'src/components/table/LegacyTable/LegacyCustomTable';
import { useGetPublication } from 'src/hooks/api/publication/useGetPublication';
import { PublicationTypes } from 'src/interfaces';
import { formatTimestamp } from 'src/utils/date';
import { lang } from 'src/utils/language';

export enum ProductPublicationColumns {
  NAME = 'name',
  LAST_MODIFIED = 'last_modified',
  LAST_PUBLISHED = 'last_published',
}

const headers = [
  { key: ProductPublicationColumns.NAME, label: 'Name', flex: 2 },
  { key: ProductPublicationColumns.LAST_MODIFIED, label: 'Last modified' },
  {
    key: ProductPublicationColumns.LAST_PUBLISHED,
    label: 'Last published',
    tooltip: lang.publicationPage.product.lastPublishedTooltip,
    flex: 1,
  },
];

export const ProductPublicationTable = () => {
  const { data } = useGetPublication(PublicationTypes.PRODUCTS);

  const items = [
    {
      [ProductPublicationColumns.NAME]: 'Product Updates',
      [ProductPublicationColumns.LAST_MODIFIED]: formatTimestamp(
        data?.last_modified_at ?? '',
      ),
      [ProductPublicationColumns.LAST_PUBLISHED]: formatTimestamp(
        data?.last_published_at ?? '',
      ),
    },
  ];

  return <LegacyCustomTable headers={headers} items={items} />;
};
